// extracted by mini-css-extract-plugin
module.exports = {"dataList":"SideData_dataList__10JB3"};